import type { Entity } from './components'
import { worldDistanceAt } from './dungeon/depth-field'
import { T } from './tunables'

// Depth = graph distance from the hub in the walled world (B2), radial
// distance in open water. worldDistanceAt owns the switch.

export function depthFactor(player: Entity): number {
  const d = worldDistanceAt(player.position.x, player.position.y)
  return Math.max(0, Math.min(1, (d - T.biomes.hubRadius) / (T.biomes.fullDepthDist - T.biomes.hubRadius)))
}
